function customerDataReducer(state = { productData: "", productDataQRCode: "", productInfoFromModal: "", customerModalStatus: "", customerList: [], customerBaseInfoes: null }, action) {

  switch (action.type) {

    case "FETCH_DATA_PRODUCT":
      return {
        ...state,
        productData: action.data
      };

    case "FETCH_DATA_MODELS":
      return {
        ...state,
        models: action.data
      };
    case "ADD_CUSTOMER":
      return {
        ...state,
        result: action.data
      }
    case "FETCH_CUSTOMER":
      return {
        ...state,
        currentCustomer: action.data
      }
    case "FETCH_PRODUCT_BY_QRCODE":
      return {
        ...state,
        productDataQRCode: action.data
      }
    case "SEARCH_PRODUCT_SELECT":
      return {
        ...state,
        selectedProductList: action.data
      }
    case "PRODUCT_INFO_FROM_MODAL":
      return {
        ...state,
        productInfoFromModal: action.data
      }
    case "SET_CUSTOMER_POPUP":
      return {
        ...state,
        customerModalStatus: action.data
      }
    case "SEARCH_CUSTOMER":
      return {
        ...state,
        customerList: action.data
      }
    case "CUSTOMER_BASE_INFO":
      return {
        ...state,
        customerBaseInfoes: action.data
      }
    default:
      return state;
  }
}

export default customerDataReducer;